import { CommandType } from '../constants/Constants';
import BaseCommand from './BaseCommand';

/**
 * 全部清空命令
 *
 * @export
 * @class CmdRemoveAll
 * @extends {BaseCommand}
 * @author zhenliang.sun
 */
export default class CmdRemoveAll extends BaseCommand {
  constructor() {
    super();
    this.type = CommandType.RemoveAll;
    this.executing = false;
  }

  execute() {
    super.execute();
    // ItemManager.getInstance().removeAll()
    this.app.items.removeAll();
  }
}
